export const SOCIAL_LINKS = {
  github: "https://github.com/millythedev",
  linkedin: "https://www.linkedin.com/in/emilio-cleveland",
  instagram: "https://www.instagram.com",
};

export const NAV_ITEMS = [
  { label: "home", href: "#home" },
  { label: "about", href: "#about" },
  { label: "skills", href: "#skills" },
  { label: "projects", href: "#projects" },
  { label: "contact", href: "#contact" },
];

export const SKILLS = {
  technicalSkills: [
    "C/C++",
    "Python",
    "HTML5",
    "JavaScript",
    "Web Design",
    "Adobe Creative Cloud",
    "3D Printing/Designing",
    "Computer Technician",
    "Microsoft Office Applications",
    // Added from project tags:
    "ReactJS",
    "API",
    "NodeJS",
    "Emulation",
    "React",
  ],
  softSkills: [
    {
      id: "01",
      title: "non-stop learning",
      description: "Technology never stops updating, that's why those who work with technology should not stop updating themselves either."
    },
    {
      id: "02",
      title: "communicative",
      description: "No matter your profession, communication is always a need in any field."
    },
    {
      id: "03",
      title: "open-minded",
      description: "When you work for people, you need to accept new ideas from clients or team members and be able to work on them."
    }
  ]
};

export const PROJECTS = [
  {
    title: "Better Weather",
    description: "A clean and accurate weather app showing local and global forecasts with modern design.",
    image: "https://uizard.io/static/89cb1d30cdee9c19b0ce72efe004ff49/a8e47/f5e31989f816c5b15c47cd54b0eb0b30b210b6f0-1440x835.png",
    tags: ["ReactJS", "API"],
    github: "https://github.com/YOURUSER/better-weather",
    link: "https://better-weather.com"
  },
  {
    title: "BetterJungle",
    description: "E-commerce analytics dashboard for Amazon sellers featuring sales and profit insights.",
    image: "https://www.junglescout.com/wp-content/uploads/2024/03/Screen-Shot-2024-03-12-at-4.39.41-PM.png",
    tags: ["ReactJS", "NodeJS"],
    github: "https://github.com/YOURUSER/betterjungle",
    link: "https://betterjungle.com"
  },
  {
    title: "GameBoy Emulator",
    description: "A browser-based Game Boy emulator supporting classic games and save states.",
    image: "https://play-lh.googleusercontent.com/-CBEzfqzqXVejF3lECo7lCfKdAXuaAJUdb4cNcaGGB4uTwVMxqRXi1qWn1xmi2xA81I=w526-h296-rw",
    tags: ["JavaScript", "Emulation"],
    github: "https://github.com/YOURUSER/gameboy-emulator",
    link: "https://gameboy-emulator.com"
  },
  {
    title: "Pokedex Web App",
    description: "A responsive Pokédex web app for learning about Pokémon, searching by region and number.",
    image: "https://miro.medium.com/v2/resize:fit:1400/1*1JVa12hgY3oFKy89HB6ylA.png",
    tags: ["React"],
    github: "https://github.com/YOURUSER/pokedex-web-app",
    link: "https://pokedex-web-app.com"
  },
];
